export default __webpack_public_path__ + "static/media/VID-20220612-WA0004.31af2fa1.mp4";